<!-- components/bandi-container/bandi-container.component.html -->
<div class="bandi-container">
  <!-- Filters Header -->
  <ng-container *ngIf="filters">
    <div class="filters-header">
      <div class="filters-row">
        <mat-form-field appearance="outline" class="filter-select">
          <mat-label>Settore</mat-label>
          <mat-select multiple [formControl]="getFormField('sectors')">
            <mat-option *ngFor="let option of sectors$ | async" [value]="option.id">
              {{ option.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="filter-select">
          <mat-label>Beneficiari</mat-label>
          <mat-select multiple [formControl]="getFormField('beneficiaries')">
            <mat-option *ngFor="let option of beneficiaries$ | async" [value]="option.id">
              {{ option.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="filter-select">
          <mat-label>Tipologia di bando</mat-label>
          <mat-select multiple [formControl]="getFormField('types')">
            <mat-option *ngFor="let option of types$ | async" [value]="option.id">
              {{ option.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="filter-select">
          <mat-label>Territorio</mat-label>
          <mat-select multiple [formControl]="getFormField('regions')">
            <mat-option *ngFor="let option of regions$ | async" [value]="option.id">
              {{ option.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="filter-select">
          <mat-label>Programmi Europei</mat-label>
          <mat-select multiple [formControl]="getFormField('programs')">
            <mat-option *ngFor="let option of programs$ | async" [value]="option.id">
              {{ option.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-button color="primary" (click)="resetFilters()">Reset filtri</button>
        <button mat-raised-button color="primary" (click)="saveSearch()">Salva Ricerca</button>
      </div>

      <div class="search-row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput placeholder="Ricerca bandi..." [formControl]="getFormField('search')">
        </mat-form-field>
        <div class="view-options">
          <mat-form-field appearance="outline">
            <mat-label>Ordina per</mat-label>
            <mat-select [formControl]="getFormField('ordering')">
              <mat-option *ngFor="let option of orderingOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-button-toggle-group [formControl]="getFormField('status')">
            <mat-button-toggle [value]="null">Tutti</mat-button-toggle>
            <mat-button-toggle [value]="1">Aperti</mat-button-toggle>
            <mat-button-toggle [value]="2">In uscita</mat-button-toggle>
          </mat-button-toggle-group>
          <mat-slide-toggle [formControl]="getFormField('showFavorites')">
            Mostra solo preferiti
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Results -->
  <ng-container *ngIf="bandiResponse$ | async as response">
    <ng-container [ngSwitch]="layout">
      <ng-container *ngSwitchCase="'list'">
        <ng-container *ngTemplateOutlet="listTemplate; context: {$implicit: response}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'carousel'">
        <ng-container *ngTemplateOutlet="carouselTemplate; context: {$implicit: response}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
      </ng-container>
    </ng-container>
    <!-- <div class="results-header">
      <h1>{{ response.payload.count }} bandi</h1>
      <span class="update-date">
        Ultimo aggiornamento il {{ response.payload.results[0].published | date:'dd MMMM yyyy' }}
      </span>
    </div>

    <div class="bandi-list" *ngIf="!loading; else loadingTpl">
      <app-bando-card *ngFor="let bando of response.payload.results; trackBy: trackByBandoId" [bando]="bando"
        (favoriteToggle)="onFavoriteToggle($event)"></app-bando-card>
    </div>

    <mat-paginator [length]="response.payload.count" [pageSize]="20" [pageIndex]="filtersSubject.getValue().page! - 1"
      (page)="onPageChange($event.pageIndex + 1)">
    </mat-paginator> -->
  </ng-container>

  <!-- <div class="loading-overlay" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div> -->
</div>

<ng-template #loadingTpl>
  <div class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-template>

<ng-template #listTemplate let-response>
  <div class="results-header">
    <h1>{{ response.payload.count }} bandi</h1>
    <span class="update-date">
      Ultimo aggiornamento il {{ response.payload.results[0].published | date:'dd MMMM yyyy' }}
    </span>
  </div>

  <div class="bandi-list" *ngIf="!loading; else loadingTpl">
    <app-bando-card *ngFor="let bando of response.payload.results; trackBy: trackByBandoId" [bando]="bando"
      (favoriteToggle)="onFavoriteToggle($event)"></app-bando-card>
  </div>

  <mat-paginator [length]="response.payload.count" [pageSize]="20" [pageIndex]="filtersSubject.getValue().page! - 1"
    (page)="onPageChange($event.pageIndex + 1)">
  </mat-paginator>

</ng-template>

<ng-template #carouselTemplate let-response>
  <ng-container *ngIf="!loading; else loadingTpl">
    <angular-carousel class="bandi-carousel" [infinite]="true" [auto]="false" [duration]="3000">
      <ng-container *ngFor="let bando of response.payload.results; trackBy: trackByBandoId">
        <div *angularCarouselSlide class="bandi-slides">
        <app-bando-item [bando]="bando" (onBandoClicked)="goToBandi($event)"></app-bando-item>
        </div>
      </ng-container>
    </angular-carousel>
  </ng-container>
</ng-template>
